import {Component, Input, OnInit} from '@angular/core';
import {ApexOptions} from "ng-apexcharts";

import {AppOriginationListDialogComponent} from "./app-origination-list-dialog/app-origination-list-dialog.component";
import { StartupContactModel } from 'app/models/contact-form/startup-contact.model';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-app-origination-pie-chart',
    templateUrl: './app-origination-pie-chart.component.html',
    styleUrls: ['./app-origination-pie-chart.component.scss']
})
export class AppOriginationPieChartComponent implements OnInit {
    private _originationData: any;
    get originationData() {
        return this._originationData;
    }

    @Input() set originationData(val: any) {
        this._originationData = val;
        if (val) {
            this.originationChart = {
                chart: {
                    toolbar: {
                        show: true
                    },
                    animations: {
                        speed: 400,
                        animateGradually: {
                            enabled: false
                        }
                    },
                    fontFamily: 'inherit',
                    foreColor: 'inherit',
                    height: '100%',
                    type: 'pie',
                    sparkline: {
                        enabled: true
                    }
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: '13px',
                        // fontWeight: 'bold',
                    },
                    dropShadow: {enabled: false}
                },
                colors: ['#C6D9AB', '#C8684F', '#E1C3AB', '#FFEBAC',
                    '#51425F', '#70a670', '#577794', '#9183d2',
                    '#8a6857'],
                labels: this._originationData.labels,
                plotOptions: {
                    pie: {
                        customScale: 0.9,
                        expandOnClick: false,
                        donut: {
                            size: '70%'
                        },
                        dataLabels: {
                            offset: -20,
                        }
                    }
                },
                series: this._originationData.series.map(p => p.percentageValue),
                states: {
                    hover: {
                        filter: {
                            type: 'none'
                        }
                    },
                    active: {
                        filter: {
                            type: 'none'
                        }
                    }
                },
                tooltip: {
                    enabled: true,
                    fillSeriesColor: false,
                    theme: 'dark',
                    custom: ({
                                 seriesIndex,
                                 w
                             }): string => `<div class="flex items-center h-8 min-h-8 max-h-8 px-3">
                                                    <div class="w-3 h-3 rounded-full" style="background-color: ${w.config.colors[seriesIndex]};"></div>
                                                    <div class="ml-2 text-md leading-none">${w.config.labels[seriesIndex]}:</div>
                                                    <div class="ml-2 text-md font-bold leading-none">${w.config.series[seriesIndex]}%</div>
                                                </div>`
                }
            };

        }
    }

    @Input() applicationList: StartupContactModel[];
    originationChart: ApexOptions;

    constructor(private _matDialog: MatDialog,
    ) {
    }

    ngOnInit(): void {
    }

    openInfoPopup(origination: any) {
        console.log(origination);
        console.log(this.applicationList);

        const filteredApps = this.applicationList && this.applicationList.length ?
            this.applicationList.filter(a=> a.origination.toUpperCase() === origination.toUpperCase()) : []

        this._matDialog.open(AppOriginationListDialogComponent, {
            autoFocus: false,
            data: {
                origination,
                filteredApps
            }
        },)
            .afterClosed()
            .subscribe(() => {

                // Go up twice because card routes are setup like this; "card/CARD_ID"
                // this._router.navigate(['./../..'], {relativeTo: this._activatedRoute});
            });
    }
}
